import React, { useEffect, useRef } from 'react';
import { Box, Divider, FormHelperText, Stack, Typography } from '@mui/material';
import { linkifyText } from '../../utils/api/text';

interface TerminalWindowProps {
	title: string;
	content: string[];
	titleAdornment: React.ReactNode;
}

const TerminalWindow: React.FC<TerminalWindowProps> = ({ title, content, titleAdornment }) => {
	const textRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (textRef.current) {
			textRef.current.scrollTop = textRef.current.scrollHeight;
		}
	}, [content]);

	return (
		<Box width="100%">
			<Box bgcolor={'action.hover'} width="100%" paddingX={1}>
				<Stack direction="row" justifyContent={'space-between'} alignItems={'center'}>
					<FormHelperText sx={{ fontSize: '1em' }}>{title}</FormHelperText>
					{titleAdornment}
				</Stack>
			</Box>
			<Box
				bgcolor={'action.selected'}
				data-testid="terminal-window-textfield"
				width="100%"
				minHeight={'18em'}
				maxHeight={'18em'}
				overflow={'auto'}
				padding={1}
				ref={textRef}
			>
				<Stack spacing={1}>
					{content.map((text, i) => {
						return (
							<React.Fragment key={`terminal-window-text-entry-${i}`}>
								<Typography>{linkifyText(text)}</Typography>
								{i + 1 < content.length && (
									<Divider
										sx={{
											alignSelf: 'center',
											width: '90%',
										}}
									/>
								)}
							</React.Fragment>
						);
					})}
				</Stack>
			</Box>
		</Box>
	);
};

export default TerminalWindow;
